module.exports = __webpack_public_path__ + "img/logo_goAllOutMan_run.bd0f9ab0.png";